import { WaybillIdView } from '../../../../models/shipment-id-view.model';

export class ShipmentWaybillCommentsLoad {
  public static readonly type = '[ShipmentWaybillComments] Load';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillCommentsSave {
  public static readonly type = '[ShipmentWaybillComments] Save Comment';
  constructor(public payload: { waybill: WaybillIdView; comment: string }) {}
}

export class ShipmentWaybillCommentsInitialState {
  public static readonly type = '[ShipmentWaybillComments] Set Initial State';
}
